import { get, isEmpty, values } from 'lodash';
import { FlowNode } from '../flowState';

const hasInvalidMappings = (node: FlowNode) => {
  const meta = node.meta;
  return !isEmpty(
    values(get(meta, ['validation', 'params', 'invalid_mappings']))
  );
};

export default hasInvalidMappings;
